'use strict';

var Types = require('./types');

var internals = {};

module.exports = function (_ref) {
    var login = _ref.login;
    var logout = _ref.logout;


    if (!login) {
        throw new Error('You must at least specify a login callback.');
    }

    var loginCb = internals.wrapToUseCallback(login);
    var logoutCb = logout ? internals.wrapToUseCallback(logout) : function (cb) {
        return cb(null);
    };

    var actions = {
        loginAttempt: function loginAttempt() {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return {
                type: Types.LOGIN_ATTEMPT,
                payload: args
            };
        },
        loginFail: function loginFail(error) {

            return {
                type: Types.LOGIN_FAIL,
                payload: error,
                error: true
            };
        },
        loginSuccess: function loginSuccess(_ref2) {
            var credentials = _ref2.credentials;
            var artifacts = _ref2.artifacts;


            credentials = credentials || null;
            artifacts = artifacts || null;

            return {
                type: Types.LOGIN_SUCCESS,
                payload: { credentials: credentials, artifacts: artifacts }
            };
        },
        // Whatever args taken by loginCb, minus final callback
        login: function login() {
            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            return function (dispatch) {

                dispatch(actions.loginAttempt.apply(actions, args));

                return loginCb.apply(undefined, args.concat([function (err, result) {

                    if (err) {
                        return dispatch(actions.loginFail(err));
                    }

                    return dispatch(actions.loginSuccess({
                        credentials: result.credentials,
                        artifacts: result.artifacts
                    }));
                }]));
            };
        },
        // Whatever args taken by logoutCb, minus final callback
        logoutAttempt: function logoutAttempt() {
            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
            }

            return {
                type: Types.LOGOUT_ATTEMPT,
                payload: args
            };
        },
        logoutFail: function logoutFail(error) {

            return {
                type: Types.LOGOUT_FAIL,
                payload: error,
                error: true
            };
        },
        logoutSuccess: function logoutSuccess(info) {

            return {
                type: Types.LOGOUT_SUCCESS,
                payload: info
            };
        },
        // Whatever args taken by logoutCb, minus final callback
        logout: function logout() {
            for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                args[_key4] = arguments[_key4];
            }

            return function (dispatch) {

                dispatch(actions.logoutAttempt.apply(actions, args));

                return logoutCb.apply(undefined, args.concat([function (err, info) {

                    if (err) {
                        return dispatch(actions.logoutFail(err));
                    }

                    return dispatch(actions.logoutSuccess(info || null));
                }]));
            };
        }
    };

    return actions;
};

internals.wrapToUseCallback = function (fn) {

    return function () {
        for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            args[_key5] = arguments[_key5];
        }

        var cb = args.pop(); // Pop last param off args– will be the callback

        var called = false;
        var onceCb = function onceCb(err, result) {

            if (called) {
                throw new Error('You might be doing something weird.  The login or logout callback was called twice.');
            }

            called = true;
            cb(err, result);
        };

        var maybePromise = fn.apply(undefined, args.concat([onceCb]));

        if (!maybePromise || typeof maybePromise.then !== 'function') {
            return;
        }

        var success = function success(result) {

            onceCb(null, result);
            return result;
        };

        var fail = function fail(err) {

            onceCb(err);
            return Promise.reject(err);
        };

        return maybePromise.then(success, fail);
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/strange-auth/lib/actions.js
// module id = 1104
// module chunks = 0